"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQueryKey = exports.NO_QUERIES_TO_INVALIDATE = exports.INVALIDATE_ALL_QUERIES = exports.INVALIDATE_ALL_ISSUES = void 0;
const NO_QUERIES_TO_INVALIDATE = exports.NO_QUERIES_TO_INVALIDATE = "no-queries-to-invalidate";
const INVALIDATE_ALL_QUERIES = exports.INVALIDATE_ALL_QUERIES = [[]];
const INVALIDATE_ALL_ISSUES = exports.INVALIDATE_ALL_ISSUES = [["issues", "?"], ["issues:batchGet"]];
const getQueryKey = (url, body) => {
  const [path, search] = url.split("?");
  const queryKey = path.split("/");

  // handle requests (e.g. getAll) which includes fetch params as query params (e.g. filter, sortBy, limit, offset)
  if (search) {
    queryKey.push("?", search);
  }

  // handle requests (e.g. batchGet) which include fetch params in body (e.g. filter, sortBy, limit, offset)
  if (body) {
    queryKey.push(body);
  }
  return queryKey;
};
exports.getQueryKey = getQueryKey;
//# sourceMappingURL=queryClientUtils.js.map